module.exports = __webpack_public_path__ + "static/media/team.6a69ff9f.png";